import React from 'react';
import * as S from './hooks.styles';
import * as Yup from 'yup';
import { DateInputField, errorMessages, SelectField } from '../../../ui/formik-controls';
import { FormFieldsFunction } from './form-fields';
import { MonthlyInterface } from '../api/report-types';
import * as _ from 'lodash';
import { usePartnerList } from '../../../../api/partner-hooks';
import moment from 'moment';

const state: Partial<MonthlyInterface> = {
  bankMnemocode: undefined,
  period: undefined,
};

const schema: Yup.Schema<object | undefined> = Yup.object().shape({
  bankMnemocode: Yup.string().required(errorMessages.required),
  period: Yup.string().required(errorMessages.required),
});

export const useMonthly: FormFieldsFunction<Partial<MonthlyInterface>> = () => {
  const bankMnemocodeOptions = _.chain(usePartnerList())
    .get('data')
    .map((partner) => ({ value: partner?.mnemocode, caption: `${partner?.mnemocode} - ${partner?.components?.name}` }))
    .value();

  function render() {
    return (
      <S.FormWrapper>
        <S.Column>
          <SelectField
            options={bankMnemocodeOptions}
            name="bankMnemocode"
            label="Банк"
            filterable={false}
            placeholder="Выберите банк"
          />
          <DateInputField
            name="period"
            label="Период"
            placeholder="YYYY-MM"
            formatDate={(date) => moment(date).format('YYYY-MM')}
            parseDate={(str) => moment(str, 'YYYY-MM').toDate()}
          />
        </S.Column>
      </S.FormWrapper>
    );
  }

  return {
    state,
    schema,
    render,
  };
};
